import { c as _c } from "react/compiler-runtime";
import { FMealDrinkTypeEnum } from '@/types/experience';
import { FDishTypeEnum } from '@/types/meal';
import DishList from './DishList';
const Dishes = (t0) => {
    const $ = _c(26);
    const { className: t1, appendTooltipTo, mealConfiguration, mealContent } = t0;
    const className = t1 === undefined ? "" : t1;
    const aperitives = mealConfiguration.drinks.aperitif > 0 && mealContent.aperitif;
    const starters = mealConfiguration.formulas.findIndex(_temp) > -1 ? mealContent.starter : null;
    const mains = mealConfiguration.formulas.findIndex(_temp2) > -1 ? mealContent.main : null;
    const desserts = mealConfiguration.formulas.findIndex(_temp3) > -1 ? mealContent.dessert : null;
    const wines = mealConfiguration.drinks.wine > 0 && mealContent.wine;
    const digestives = mealConfiguration.drinks.digestive > 0 && mealContent.digestive;
    const computedClassName = `w-full ${className}`;
    let t2;
    if ($[0] !== aperitives || $[1] !== appendTooltipTo) {
        t2 = aperitives &&
            <DishList type={FMealDrinkTypeEnum.aperitif} dishes={aperitives} appendTooltipTo={appendTooltipTo}/>;
        $[0] = aperitives;
        $[1] = appendTooltipTo;
        $[2] = t2;
    }
    else {
        t2 = $[2];
    }
    let t3;
    if ($[3] !== appendTooltipTo || $[4] !== starters) {
        t3 = starters &&
            <DishList type={FDishTypeEnum.Starter} dishes={starters} appendTooltipTo={appendTooltipTo}/>;
        $[3] = appendTooltipTo;
        $[4] = starters;
        $[5] = t3;
    }
    else {
        t3 = $[5];
    }
    let t4;
    if ($[6] !== appendTooltipTo || $[7] !== mains) {
        t4 = mains &&
            <DishList type={FDishTypeEnum.Main} dishes={mains} appendTooltipTo={appendTooltipTo}/>;
        $[6] = appendTooltipTo;
        $[7] = mains;
        $[8] = t4;
    }
    else {
        t4 = $[8];
    }
    let t5;
    if ($[9] !== appendTooltipTo || $[10] !== desserts) {
        t5 = desserts &&
            <DishList type={FDishTypeEnum.Dessert} dishes={desserts} appendTooltipTo={appendTooltipTo}/>;
        $[9] = appendTooltipTo;
        $[10] = desserts;
        $[11] = t5;
    }
    else {
        t5 = $[11];
    }
    let t6;
    if ($[12] !== appendTooltipTo || $[13] !== wines) {
        t6 = wines &&
            <DishList type={FMealDrinkTypeEnum.wine} dishes={wines} appendTooltipTo={appendTooltipTo}/>;
        $[12] = appendTooltipTo;
        $[13] = wines;
        $[14] = t6;
    }
    else {
        t6 = $[14];
    }
    let t7;
    if ($[15] !== appendTooltipTo || $[16] !== digestives) {
        t7 = digestives &&
            <DishList type={FMealDrinkTypeEnum.digestive} dishes={digestives} appendTooltipTo={appendTooltipTo}/>;
        $[15] = appendTooltipTo;
        $[16] = digestives;
        $[17] = t7;
    }
    else {
        t7 = $[17];
    }
    let t8;
    if ($[18] !== computedClassName || $[19] !== t2 || $[20] !== t3 || $[21] !== t4 || $[22] !== t5 || $[23] !== t6 || $[24] !== t7) {
        t8 = <div className={computedClassName}>{t2}{t3}{t4}{t5}{t6}{t7}
    </div>;
        $[18] = computedClassName;
        $[19] = t2;
        $[20] = t3;
        $[21] = t4;
        $[22] = t5;
        $[23] = t6;
        $[24] = t7;
        $[25] = t8;
    }
    else {
        t8 = $[25];
    }
    return t8;
};
export default Dishes;
function _temp(f) { return f.starters > 0; }
function _temp2(f_0) { return f_0.mains > 0; }
function _temp3(f_1) { return f_1.desserts > 0; }
